import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import TreeItem from '@material-ui/lab/TreeItem';

// @material-ui/icons
import GetAppIcon from '@material-ui/icons/GetApp';
import WebAssetIcon from '@material-ui/icons/WebAsset';

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import { API_BASE_URL } from "views/api"

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

const useStyles = makeStyles(styles);

const tree_item_style= {
  margin: '15px',
  color: '#567',
  width: '95%'
}

const downBtn =
<div
  style={{
    float: 'right', position:'absolute', right: '40px', marginTop: '-40px'
}}>
    <GetAppIcon style={{color:"#567"}}/>
</div>
const viewBtn =
<div
  style={{
    float: 'right', position:'absolute', right: '70px', marginTop: '-40px'
}}>
    <WebAssetIcon style={{color:"#567"}}/>
</div>

const all_directory = [
  {name: 'जि.स.स. भक्तपुर', link_ref:"bhaktapur_district"},
  {name: 'चाँगुनारायण नगरपालिका', link_ref:"changunarayan"},
  {name: 'भक्तपुर नगरपालिका', link_ref:"bhaktapur"},
  {name: 'मध्यपुर थिमि नगरपालिका', link_ref:"madhyapur_thimi"},
  {name: 'सूर्यविनायक नगरपालिका', link_ref:"suryabinayak"},
];
const all_category = [
  {name: 'नियमावली', link_ref:"rules"},
  {name: 'ऐन कानुन', link_ref:"law"},
  {name: 'कार्यविधिहरु', link_ref:"procedures"},
  {name: 'निर्देशिका', link_ref:"directory"},
  {name: 'मापदण्ड', link_ref:"criteria"},
];

export default function ProductSection() {
  const classes = useStyles();
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [fileCategory, setFileCategory] = React.useState(0);
  const [file_address, setFileAddress] = React.useState(API_BASE_URL + 'legal-collection/file/?category=' + all_category[fileCategory].link_ref + '&municipality=' + all_directory[activeIndex].link_ref);
  const [file_list, setFileList] = React.useState(undefined);

  React.useEffect(() => {
    if (file_list === undefined) {
      fetch(file_address)
        .then(results => results.json())
        .then(data => {
            console.log(data.results);
            setFileList(data.results);
        });
    }
  });

  const fileList =
      <div>
        {file_list && file_list.map((file)=>
          <div>
            <a href={file.file}>
              <TreeItem style={tree_item_style} label={file.title} />
              <a href={file.file} target="_blank" rel="noopener noreferrer">{viewBtn}</a>
              <a download href={file.file} target="_blank" rel="noopener noreferrer">{downBtn}</a>
            </a>
          </div>
        )}
      </div>


  return (
    <div className={classes.section}>
      <GridContainer md={12}>
        <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'left' }}>
          <div md={12} style={{ paddingLeft: '10px',color: "#134c7a", margin: 0, borderLeft: "5px solid #134c7a" }}>
            <small>अभिलेख</small>
            <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a'}}>ऐन कानून</h3></span>
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'left', color: '#333' }}>
          ऐन कानून सँग सम्बन्धित कागजातहरू हेर्न र डाउनलोड गर्नको लागि, नगरपालिका र कागजातको प्रकार छान्नुहोस्।
        </GridItem>
        <GridItem xs={6} sm={3} md={2} style={{ color: '#333' }}>
          <GridItem xs={12} sm={12} md={12} style={{ color: '#333', marginBottom: '10px', marginTop: '20px', fontWeight: 'bold' }}>निकाय</GridItem>
              {
                all_directory.map((directory, value) => {
                  return (
                    <div>
                      <Button
                        fullWidth
                        style={{ margin: 0 }}
                        color={activeIndex === value ? "primary" : "transparent"}
                        onClick={() => {
                          setFileList(undefined);
                          setActiveIndex(value);
                          setFileAddress(API_BASE_URL + 'legal-collection/file/?category=' + all_category[fileCategory].link_ref + '&municipality=' + all_directory[value].link_ref)
                        }}
                      >
                        {all_directory[value].name}
                      </Button>
                    </div>
                  );
                })
              }
        </GridItem>
        <GridItem xs={6} sm={3} md={2} style={{ color: '#333' }}>
          <GridItem xs={12} sm={12} md={12} style={{ color: '#333', marginBottom: '10px', marginTop: '20px', fontWeight: 'bold' }}>कागजातको प्रकार</GridItem>
              {all_category.map((category, value) => {
                return (
                  <div style={{ backgroundColor: '#eee' }}>
                    <Button
                      fullWidth
                      style={{ margin: 0 }}
                      color={value === fileCategory ? "primary" : "transparent"}
                      onClick={ () => {
                        setFileList(undefined);
                        setFileCategory(value);
                        setFileAddress(API_BASE_URL + 'legal-collection/file/?category=' + all_category[value].link_ref + '&municipality=' + all_directory[activeIndex].link_ref)
                      }}
                    >
                      {category.name}
                    </Button>
                  </div>
                );
              })}
        </GridItem>
        <GridItem xs={12} sm={6} md={8} style={{ color: '#333', textAlign: 'left' }}>
          <GridItem xs={12} sm={12} md={12} style={{ color: '#333', marginBottom: '10px', marginTop: '20px', fontWeight: 'bold', textAlign: 'left' }}>कागजातहरू</GridItem>
          <div style={{ color: '#333', width: '100%', backgroundColor: '#eee' }}>
            <GridContainer xs={12} sm={12} md={12}>
                <div style={{ color: '#333', width: '100%', backgroundColor: '#eee', minHeight: '370px' }}>
                  {file_list && (file_list.toString() === [].toString()) && <h3 style={{ position: 'absolute', paddingLeft: '30px' }}>उपलब्ध छैन</h3>}
                  {file_list === undefined && <div className="lds-ellipsis extra-color-blue"><div></div><div></div><div></div><div></div></div>}
                  {fileList}
                </div>
            </GridContainer>
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
